import type { Address } from '@rover/types/src/Address';

const defaults: Address = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: '',
  countryCode: '',
  accessToHome: '',
};

export default function addressFactory(address?: Partial<Address>): Address {
  return { ...defaults, ...address };
}
